/** `/$org/apps/contract-intelligence/new`: add documents, choose the basis, run. */
import { createFileRoute } from "@tanstack/react-router";

import { CiNewReviewPage } from "../components/apps/contractIntelligence/CiNewReviewPage";

export const Route = createFileRoute("/$org/apps/contract-intelligence/new")({
  component: CiNewReviewPage,
});
